import React from 'react';
import { useNavigate } from 'react-router-dom';

import FacebookIcon from '../Images/facebook.png';
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.png';
import InstagramIcon from '../Images/instagram.png';
import Logo from '../Images/mindronlogo_bg.png';

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = (item) => {
    const productMap = {
      'ECG (Electrocardiograph)': '/products/ecg',
      'Multipara Monitor': '/products/multiparamonitor',
      'Portable Ultrasound Machine': '/products/portableultrasoundmachine',
      Cardiotocography: '/products/cardiotocography',
      'Auto Hematology Analyzer': '/products/autohematologyanalyzer',
      'Magnetic Resonance Pancreatography': '/products/mrp',
    };

    if (productMap[item]) {
      navigate(productMap[item]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (item === 'Contact Us' || item === 'Join Us') {
      navigate('/contact');
      window.scrollTo({ top: 600, behavior: 'smooth' });
    } else if (item === 'About' || item === 'Our Mission' || item === 'Vision') {
      const sectionKey = item.toLowerCase().replace(/\s+/g, '');
      navigate('/about', { state: { scrollTo: sectionKey } });
      window.scrollTo({ top: 600, behavior: 'smooth' });
    }
  };

  const sections = [
    {
      title: 'Products',
      items: [
        'ECG (Electrocardiograph)',
        'Multipara Monitor',
        'Cardiotocography',
        'Auto Hematology Analyzer',
        'Portable Ultrasound Machine',
      ],
    },
    {
      title: 'About us',
      items: ['About', 'Our Mission', 'Vision'],
    },
    {
      title: 'Contact us',
      items: [
        'info@mindronmeditech.com',
        '8655972632 / 022 4516 6539',
        '© 2025 MindronMediTech India Pvt. Ltd. All rights reserved.',
      ],
    },
  ];

  const clickableItems = [
    'Contact Us',
    'Join Us',
    'About',
    'Our Mission',
    'Vision',
    'ECG (Electrocardiograph)',
    'Multipara Monitor',
    'Cardiotocography',
    'Auto Hematology Analyzer',
    'Portable Ultrasound Machine',
  ];

  return (
    <div
      style={{
        backgroundColor: '#0a1628',
        color: '#ccc',
        padding: '36px 4%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '32px',
        boxSizing: 'border-box',
        fontSize: '13px',
        marginTop: '60px',
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)',
      }}
    >
      {/* LEFT: Logo + Tagline */}
      <div style={{ flex: '0 0 180px', minWidth: '160px' }}>
        <div
          style={{
            borderRadius: '6px',
            padding: '8px 10px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '16px',
          }}
        >
          <img
            src={Logo}
            alt="Mindron Logo"
            style={{
              width: '120px',
              height: '60px',
              objectFit: 'contain',
            }}
          />
        </div>

        <p
          style={{
            color: '#aab',
            fontSize: '13px',
            lineHeight: '1.7',
            margin: 0,
            fontWeight: '600',
          }}
        >
          Excellence in medical equipment,
          <br />
          driven by innovation and dedicated to
          <br />
          patient care.
        </p>
      </div>

      {/* MIDDLE: Nav Columns */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '40px',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        {sections.map((section, index) => (
          <div key={index} style={{ minWidth: '140px' }}>
            <div
              style={{
                color: '#fff',
                fontWeight: '700',
                marginBottom: '12px',
                fontSize: '13px',
              }}
            >
              {section.title}
            </div>

            <ul
              style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
              }}
            >
              {section.items.map((item, i) => (
                <li
                  key={i}
                  onClick={() => handleClick(item)}
                  style={{
                    marginBottom: '8px',
                    color: '#aab',
                    fontSize: '13px',
                    cursor: clickableItems.includes(item) ? 'pointer' : 'default',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#aab';
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* RIGHT: Terms + Social */}
      <div
        style={{
          flex: '0 0 auto',
          minWidth: '140px',
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '40px',
        }}
      >
        {/* Terms & Privacy */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <span
            style={{
              color: '#aab',
              cursor: 'pointer',
              fontSize: '13px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#aab';
            }}
          >
            Terms of Service
          </span>

          <span
            style={{
              color: '#aab',
              cursor: 'pointer',
              fontSize: '13px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#aab';
            }}
          >
            Privacy Policy
          </span>
        </div>

        {/* Social Icons */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '10px',
          }}
        >
          <span
            style={{
              color: '#aab',
              fontSize: '13px',
              marginRight: '4px',
            }}
          >
            Join us:
          </span>

          <a
            href="https://www.facebook.com/mindronmeditech"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={FacebookIcon}
              alt="Facebook"
              style={{ width: '24px', height: '24px' }}
            />
          </a>

          <a
            href="https://www.instagram.com/mindronmeditech/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={InstagramIcon}
              alt="Instagram"
              style={{ width: '24px', height: '24px' }}
            />
          </a>

          <a
            href="https://twitter.com/Mindrommtech"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={TwitterIcon}
              alt="Twitter"
              style={{ width: '24px', height: '24px' }}
            />
          </a>

          <a
            href="https://www.linkedin.com/in/mindron-meditech-53b2b9370/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={LinkedInIcon}
              alt="LinkedIn"
              style={{ width: '24px', height: '24px' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;